import {getQuery, postQuery, putQuery} from "../../common/utils";
const Qs = require('qs');

const get = async (page, search_expression, states, staff_ids, start_time, end_time, sort_direction, payment_status_states) => {
  const params = {
    entity: 'appointment',
    page: page || 1,
    per_page: 20,
    group_by: "pivot_service_id",
    initiated_by_staff: true,
  };

  if (search_expression) {
    params.query = search_expression;
  }

  const search_filter = {};

  search_filter.sort_type = "start_time";

  search_filter.sort_order = sort_direction;

  if (states && states.indexOf('no_show') !== -1) {
    search_filter.no_show_filter = true;
  }

  const states_without_no_show = states && states.filter(item => item !== 'no_show');
  if (states_without_no_show && states_without_no_show.length > 0) {
    search_filter.state_filter = states_without_no_show.join();
  }

  if (payment_status_states && payment_status_states.length > 0) {
    search_filter.payment_status_state_filter = payment_status_states.join();
  }

  if (start_time) {
    search_filter.from_filter = start_time;
  }

  if (end_time) {
    search_filter.to_filter = end_time;
  }

  if (staff_ids && staff_ids.length > 0) {
    search_filter.staff_filter = staff_ids.join();
  }

  if (Object.keys(search_filter).length > 0) {
    params.search_filter = search_filter;
  }

  let result;
  try {
    result = await getQuery('search', params, params => Qs.stringify(params, {arrayFormat: 'brackets'}));
    result = result.data;
    result.appointments = result.appointments.map(item => {return {...item, uid: item.id}});
  }
  catch (error) {
    result = {code: 'missing'};
  }

  return result;
};

export const createAppointment = async (params) => {
  return await postQuery('/appointments', params)
}

export const editAdditionalStaff = async (additionalStaffUids, appointmentUid, applySeries) => {
  const params = {
    additional_staffs: additionalStaffUids.join(', '),
    apply_series: applySeries
  }
  return await putQuery(`/appointments/${appointmentUid}`, params)
}

export const createEvent = async (params) => {
  return await postQuery('/event_instances', params)
}

export const getStaffOfferedServices = (staff_id, service_uid) => {
  return getQuery('offered_services', {staff_id, by_service: service_uid})
}

export const getRecurrenceDescription = ({time_start, frequency, rule_type, count, monthly_type, til, days_of_week}) => {
  return getQuery('event_series/description', {
    time_start,
    frequency,
    rule_type,
    count,
    monthly_type,
    til,
    days_of_week,
  })
}

export const bookingsService = {
  get,
  createAppointment,
  editAdditionalStaff,
  getStaffOfferedServices,
  getRecurrenceDescription,
  createEvent
};
